import type { ReportResolver } from "@/lib/reports/types";
import { faktureringsgradResolver } from "./faktureringsgrad-resolver";
import { bfResolver } from "./bf-resolver";
import { provisjonResolver } from "./provisjon-resolver";
import { budsjettavvikResolver } from "./budsjettavvik-resolver";
import { kapasitetResolver } from "./kapasitet-resolver";
import { lonnsgrunnlagResolver } from "./lonnsgrunnlag-resolver";

export const RESOLVERS: Record<string, ReportResolver> = {
  faktureringsgrad: faktureringsgradResolver,
  bf: bfResolver,
  provisjon: provisjonResolver,
  budsjettavvik: budsjettavvikResolver,
  kapasitet: kapasitetResolver,
  lonnsgrunnlag: lonnsgrunnlagResolver,
};

export function getResolver(id: string): ReportResolver | undefined {
  return RESOLVERS[id];
}
